class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  // onChange() {
  //   super.onChange();
  //   let e = this.getQuery();

  //   if (
  //     this.searchTerm && e.startsWith(this.searchTerm) ||
  //     this.querySelector("#predictive-search-results-groups-wrapper")?.remove(),
  //     this.querySelector(".predictive-search__result-group")?.remove(),
  //     this.querySelector(".no-result")?.remove(),
  //     this.updateSearchForTerm(this.searchTerm, e),
  //     this.searchTerm = e,
  //     !this.searchTerm.length
  //   ) {
  //     this.close(true);
  //     return;
  //   }

  //   this.getSearchResults(this.searchTerm);
  // }
  onChange() {
    super.onChange();

    let query = this.getQuery();

    // old results clean karo
    this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    this.querySelector(".predictive-search__result-group")?.remove();
    this.querySelector(".no-result")?.remove();

    this.searchTerm = query;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    // debounce (extra API calls rokne ke liye)
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.getSearchResults(this.searchTerm);
    }, 300);
  }

  onFormSubmit(e) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      e.preventDefault();
    }
  }

  onFormReset(e) {
    super.onFormReset(e);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    let e = this.getQuery();

    if (e.length) {
      if (this.searchTerm !== e) {
        this.onChange();
      } else if (this.getAttribute("results") === "true") {
        this.open();
      } else {
        this.getSearchResults(this.searchTerm);
      }
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  onKeyup(e) {
    if (!this.getQuery().length) {
      this.close(true);
    }

    e.preventDefault();
    this.querySelector(".no-result")?.remove();

    switch (e.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }

  onKeydown(e) {
    if (e.code === "ArrowUp" || e.code === "ArrowDown") {
      e.preventDefault();
    }
  }

  // updateSearchForTerm(e, t) {
  //   let s = this.querySelector(".search__input");
  //   let i = s?.value;

  //   if (i) {
  //     if (i.match(e) == null || i.match(e).length > 1) return;
  //     let r = i.replace(e, t);
  //     s.innerText = r;
  //   }
  // }
  updateSearchForTerm(e, t) {
    let input = this.querySelector(".search__input");
    let value = input?.value;

    if (value) {
      if (value.match(e) == null || value.match(e).length > 1) return;
      let replaced = value.replace(e, t);
      input.value = replaced; // ✅ innerText se value me change
    }
  }
  switchOption(e) {
    if (!this.getAttribute("open")) return;

    let isUp = e === "up";
    let selected = this.querySelector('[aria-selected="true"]');

    let items = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter(el => el.offsetParent !== null);

    let index = 0;

    if (isUp && !selected) return;

    let currentIndex = -1;
    let i = 0;

    for (; currentIndex === -1 && i <= items.length; ) {
      if (items[i] === selected) currentIndex = i;
      i++;
    }

    this.statusElement.textContent = "";

    if (!isUp && selected) {
      index = currentIndex === items.length - 1 ? 0 : currentIndex + 1;
    } else if (isUp) {
      index = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
    }

    if (index === currentIndex) return;

    let next = items[index];
    next.setAttribute("aria-selected", true);

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", next.id);
  }

  selectOption() {
    let el = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );
    if (el) el.click();
  }

  // getSearchResults(e) {
  //   let key = e.replace(" ", "-").toLowerCase();

  //   this.setLiveRegionLoadingState();

  //   if (this.cachedResults[key]) {
  //     this.renderSearchResults(this.cachedResults[key]);
  //     return;
  //   }

  //   let url = `${routes.predictive_search_url}`;
  //   url = url.replace("/suggest", "");

  //   fetch(
  //     `${url}?q=${encodeURIComponent(e)}&view=predective-search`,
  //     { signal: this.abortController.signal }
  //   )
  //     .then(res => {
  //       if (!res.ok) {
  //         throw Error(res.status);
  //       }
  //       return res.text();
  //     })
  //     .then(html => {
  //       let parsed = new DOMParser()
  //         .parseFromString(html, "text/html")
  //         .querySelector(".predective-grid-pick").innerHTML;

  //       this.renderSearchResults(parsed);
  //     })
  //     .catch(err => {
  //       if (err?.code !== 20) {
  //         this.close();
  //         throw err;
  //       }
  //     });
  // }
  getSearchResults(query) {
    let key = query.replace(" ", "-").toLowerCase();

    this.setLiveRegionLoadingState();

    // cache check
    if (this.cachedResults[key]) {
      this.renderSearchResults(this.cachedResults[key]);
      return;
    }

    // 🔥 previous request cancel karo
    this.abortController.abort();
    this.abortController = new AbortController();

    let url = `${routes.predictive_search_url}`;
    url = url.replace("/suggest", "");

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&section_id=predictive-search`, // ✅ spelling FIX
      { signal: this.abortController.signal }
    )
      .then(res => {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(html => {
        let doc = new DOMParser().parseFromString(html, "text/html");

        let container = doc.querySelector("#shopify-section-predictive-search");

        if (!container) {
          console.error("Predictive search container not found");
          return;
        }

        let parsed = container.innerHTML;

        this.cachedResults[key] = parsed;
        this.renderSearchResults(parsed);
      })
      .catch(err => {
        if (err.name !== "AbortError") {
          console.error(err);
          this.close();
        }
      });
  }
  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status");

    this.loadingText =
      this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(text) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = text;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(html) {
    this.predictiveSearchResults.innerHTML = html;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
  }

  // getResultsMaxHeight() {
  //   this.resultsMaxHeight =
  //     window.innerHeight -
  //     document.querySelector(".section--header").getBoundingClientRect().bottom;

  //   return this.resultsMaxHeight;
  // }
  getResultsMaxHeight() {
    let header =
      document.querySelector(".section--header") ||
      document.querySelector("header");

    if (!header) {
      return window.innerHeight;
    }

    return window.innerHeight - header.getBoundingClientRect().bottom;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;

    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }

  close(e = false) {
    this.closeResults(e);
    this.isOpen = false;
  }

  closeResults(e = false) {
    if (e) {
      this.input.value = "";
      this.removeAttribute("results");
    }

    let selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);

    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}

customElements.define("predictive-search", PredictiveSearch);

// document
//   .querySelector(".search-modal__close-button")
//   .addEventListener("click", () => {
//     document.querySelector(".reset__button.field__button").click();
//   });
document
  .querySelector(".search-modal__close-button")
  ?.addEventListener("click", () => {
    let input = document.querySelector(".search__input");
    let predictive = document.querySelector("predictive-search");

    if (input) input.value = "";
    if (predictive) predictive.close(true);
  });
// class PredictiveSearch extends SearchForm {
//   constructor() {
//     super();
//     this.cachedResults = {};
//     this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
//     this.allPredictiveSearchInstances =
//       document.querySelectorAll('predictive-search');
//     this.isOpen = false;
//     this.abortController = new AbortController();
//     this.searchTerm = '';

//     this.setupEventListeners();








//   }

//   setupEventListeners() {
//     this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

//     this.input.addEventListener('focus', this.onFocus.bind(this));
//     this.addEventListener('focusout', this.onFocusOut.bind(this));
//     this.addEventListener('keyup', this.onKeyup.bind(this));
//     this.addEventListener('keydown', this.onKeydown.bind(this));
//   }

//   getQuery() {
//     return this.input.value.trim();
//   }

//   onChange() {
//     super.onChange();
//     const newSearchTerm = this.getQuery();
//     if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
//       // Remove the results when they are no longer relevant for the new search term
//       // so they don't show up when the dropdown opens again
//       this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
//     }
//     this.querySelector(".predictive-search__result-group")?.remove();
//     this.querySelector(".no-result")?.remove();
//     // Update the term asap, don't wait for the predictive search query to finish loading
//     this.updateSearchForTerm(this.searchTerm, newSearchTerm);

//     this.searchTerm = newSearchTerm;

//     if (!this.searchTerm.length) {
//       this.close(true);
//       return;
//     }

//     this.getSearchResults(this.searchTerm);
//   }

//   onFormSubmit(event) {
//     if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
//   }

//   onFormReset(event) {
//     super.onFormReset(event);
//     if (super.shouldResetForm()) {
//       this.searchTerm = '';
//       this.abortController.abort();
//       this.abortController = new AbortController();
//       this.closeResults(true);
//     }
//   }

//   onFocus() {
//     const currentSearchTerm = this.getQuery();

//     if (!currentSearchTerm.length) return;

//     if (this.searchTerm !== currentSearchTerm) {
//       // Search term was changed from other search input, treat it as a user change
//       this.onChange();
//     } else if (this.getAttribute('results') === 'true') {
//       this.open();
//     } else {
//       this.getSearchResults(this.searchTerm);
//     }
//   }

//   onFocusOut() {
//     setTimeout(() => {
//       if (!this.contains(document.activeElement)) this.close();
//     })
//   }

//   onKeyup(event) {
//     if (!this.getQuery().length) this.close(true);
//     event.preventDefault();
//     this.querySelector(".no-result")?.remove();
//     switch (event.code) {
//       case 'ArrowUp':
//         this.switchOption('up')
//         break;
//       case 'ArrowDown':
//         this.switchOption('down');
//         break;
//       case 'Enter':
//         this.selectOption();
//         break;
//     }
//   }

//   onKeydown(event) {
//     // Prevent the cursor from moving in the input when using the up and down arrow keys
//     if (
//       event.code === 'ArrowUp' ||
//       event.code === 'ArrowDown'
//     ) {
//       event.preventDefault();
//     }
//   }

//   updateSearchForTerm(previousTerm, newTerm) {
//     const searchForTextElement = this.querySelector(".search__input");
//     // console.log(previousTerm)
//     const currentButtonText = searchForTextElement?.value;
//     if (currentButtonText) {
//       if (currentButtonText.match(previousTerm) == null || currentButtonText.match(previousTerm).length > 1) {
//         // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
//         return;
//       }
//       const newButtonText = currentButtonText.replace(previousTerm, newTerm);
//       searchForTextElement.innerText = newButtonText;
//     }
//   }

//   switchOption(direction) {
//     if (!this.getAttribute('open')) return;

//     const moveUp = direction === 'up';
//     const selectedElement = this.querySelector('[aria-selected="true"]');

//     // Filter out hidden elements (duplicated page and article resources) thanks
//     // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
//     const allVisibleElements = Array.from(
//       this.querySelectorAll("li, button.predictive-search__item")
//     ).filter((element) => element.offsetParent !== null);
//     let activeElementIndex = 0;

//     if (moveUp && !selectedElement) return;

//     let selectedElementIndex = -1;
//     let i = 0;

//     while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
//       if (allVisibleElements[i] === selectedElement) {
//         selectedElementIndex = i;
//       }
//       i++;
//     }

//     this.statusElement.textContent = "";

//     if (!moveUp && selectedElement) {
//       activeElementIndex =
//         selectedElementIndex === allVisibleElements.length - 1
//           ? 0
//           : selectedElementIndex + 1;
//     } else if (moveUp) {
//       activeElementIndex =
//         selectedElementIndex === 0
//           ? allVisibleElements.length - 1
//           : selectedElementIndex - 1;
//     }

//     if (activeElementIndex === selectedElementIndex) return;

//     const activeElement = allVisibleElements[activeElementIndex];

//     activeElement.setAttribute('aria-selected', true);
//     if (selectedElement) selectedElement.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', activeElement.id);
//   }

//   selectOption() {
//     const selectedOption = this.querySelector(
//       '[aria-selected="true"] a, button[aria-selected="true"]'
//     );

//     if (selectedOption) selectedOption.click();
//   }

//   getSearchResults(searchTerm) {
//     const queryKey = searchTerm.replace(" ", "-").toLowerCase();
//     this.setLiveRegionLoadingState();

//     if (this.cachedResults[queryKey]) {
//       this.renderSearchResults(this.cachedResults[queryKey]);
//       return;
//     }
    
//     let search__url = `${routes.predictive_search_url}`;
//      search__url = search__url.replace("/suggest", "")
//     fetch(
//       `${search__url}?q=${encodeURIComponent(
//         searchTerm
//         )}&view=predective-search`,
//         { signal: this.abortController.signal }
//       // `${routes.predictive_search_url}?q=${encodeURIComponent(
//       //   searchTerm
//       //   )}&section_id=predictive-search`,
//       // { signal: this.abortController.signal }
//     )
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           this.close();
//           throw error;
//         }

//         return response.text();
//       })
//       .then((text) => {
//         // const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
//         const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('.predective-grid-pick').innerHTML;
//         // Save bandwidth keeping the cache in all instances synced
//         // this.allPredictiveSearchInstances.forEach(
//         //   (predictiveSearchInstance) => {
//         //     predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
//         //   }
//         // );
//         this.renderSearchResults(resultsMarkup);
//       })
//       .catch((error) => {
//         if (error?.code === 20) {
//           // Code 20 means the call was aborted
//           return;
//         }
//         this.close();
//         throw error;
//       });
//   }

//   setLiveRegionLoadingState() {
//     this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
//     this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

//     this.setLiveRegionText(this.loadingText);
//     this.setAttribute('loading', true);
//   }

//   setLiveRegionText(statusText) {
//     this.statusElement.setAttribute('aria-hidden', 'false');
//     this.statusElement.textContent = statusText;

//     setTimeout(() => {
//       this.statusElement.setAttribute('aria-hidden', 'true');
//     }, 1000);
//   }

//   renderSearchResults(resultsMarkup) {
//     this.predictiveSearchResults.innerHTML = resultsMarkup;
//     this.setAttribute('results', true);

//     this.setLiveRegionResults();
//     this.open();
//   }

//   setLiveRegionResults() {
//     this.removeAttribute('loading');
//     // this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
//   }

//   getResultsMaxHeight() {
//     this.resultsMaxHeight = window.innerHeight - document.querySelector('.section--header').getBoundingClientRect().bottom;
//     return this.resultsMaxHeight;
//   }

//   open() {
//     this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
//     this.setAttribute('open', true);
//     this.input.setAttribute('aria-expanded', true);
//     this.isOpen = true;
//   }

//   close(clearSearchTerm = false) {
//     this.closeResults(clearSearchTerm);
//     this.isOpen = false;
//   }

//   closeResults(clearSearchTerm = false) {
//     if (clearSearchTerm) {
//       this.input.value = '';
//       this.removeAttribute('results');
//     }
//     const selected = this.querySelector('[aria-selected="true"]');

//     if (selected) selected.setAttribute('aria-selected', false);

//     this.input.setAttribute('aria-activedescendant', '');
//     this.removeAttribute('loading');
//     this.removeAttribute('open');
//     this.input.setAttribute('aria-expanded', false);
//     this.resultsMaxHeight = false
//     this.predictiveSearchResults.removeAttribute('style');
//   }
// }

// customElements.define('predictive-search', PredictiveSearch);

// document.querySelector(".search-modal__close-button").addEventListener("click", (event) => {
//   //handle click
//   document.querySelector(".reset__button.field__button").click()
// });